import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import Gnb from '../../components/Gnb';

import NotFoundPage from '../NotFoundPage';
import * as actions from '../../actions';

export class CouponPage extends Component {
  static propTypes = {};

  render() {
    const { coupon, showModal, wheel, device } = this.props;

    return (
      <div>
        <Gnb device={device} />

        <div id="kakaoContent" className="cont_plus" role="main">
          <div id="mArticle">
            <h2 id="kakaoBody" className="screen_out">본문영역</h2>
            <div className="view_post">
              <div className="info_err">
                <strong className="tit_err">모바일에서 확인가능한 링크입니다.</strong>
                <p className="desc_err">카카오톡이 없다면 설치 페이지로 이동합니다.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { match: { params: { couponId } } } ) => {
  const { device } = state;
  return { device };
};

export default connect(
  mapStateToProps, 
  (dispatch) => bindActionCreators({
    showModal: actions.showModal
  }, dispatch)
)(CouponPage);



// WEBPACK FOOTER //
// ./src/containers/CouponPage/index.js